import * as React from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { ISelectorDefault, search_param } from '../../_types/search';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface Props {
    onChange: IChangeEventHandler<search_param>;
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const RoleSelectorDefaults = 
    (selector_cn: string): ISelectorDefault => {
        return { 
            comparison: "equals",
            values: ["1"]
        };
    };

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
);

const RoleSelector: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();
    //const userState: IUserState = useContext(AuthContext);

    const _value = ():string => {

        let  toReturn: string = "1";
        if (prop.searchParam.values != null && prop.searchParam.values.length > 0) {
            toReturn = prop.searchParam.values[0];
        }
        return toReturn;
    }
    const handleChange = (event: React.ChangeEvent<{value: unknown}>) => {
        let checked = event.target.value as string;
 
        let p = { ...prop.searchParam };
        p.values = [ checked ];
        p.comparison = "equals";
        prop.onChange(p);
    }

return (
    
    <FormControl className={classes.formControl}>
    <InputLabel id="demo-simple-select-label">Role</InputLabel>
    <Select
      disabled={prop.disabled}
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={_value()}
      onChange={handleChange}
    >
      <MenuItem value={"1"}>Member</MenuItem>
      <MenuItem value={"2"}>Attendant</MenuItem>
      <MenuItem value={"3"}>Owner</MenuItem>
      <MenuItem value={"4"}>Admin</MenuItem>
      <MenuItem value={"5"}>SalesPerson</MenuItem>
      <MenuItem value={"6"}>Account Manager</MenuItem>
      <MenuItem value={"7"}>API</MenuItem>
    </Select>
  </FormControl>
)
}

export default RoleSelector;